import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialogPaper: { margin: 'auto' },
  dialogTitle: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  closeButton: { marginLeft: '8px', '& .MuiSvgIcon-root': { marginRight: '0px' } },
  dialogContent: { padding: '16px 24px' },
  dialogActions: { justifyContent: 'flex-end', gap: '8px', padding: '0 24px 16px', borderTop: 'none' },
  body: { display: 'flex', flexDirection: 'column', gap: '8px' },
  colorPicker: { width: '100%' },
  colorSwatch: { width: '20px', height: '20px', borderRadius: '3px', border: '1px solid #ccc' },
  saturation: { position: 'relative', width: '100%', height: '100px' },
  hue: { position: 'relative', width: '100%', height: '10px', marginTop: '8px' },
});
